import HttpService from "./HttpService";

export async function submitContactRequest(data) {
    try {
        const contactSubmitUrl = process.env.GATSBY_API_URL + "/email/contact";
        return await HttpService.post(contactSubmitUrl, data);
    } catch (e) {
        handleError(e);
    }
}

export async function getChatHours() {
    try {
        const hoursUrl = process.env.GATSBY_API_URL + "/GetChatHours";
        return await HttpService.get(hoursUrl, 'GetChatHours');
    } catch (e) {
        handleError(e);
    }
}

export async function getContactTopics() {
    try {
        const url = process.env.GATSBY_API_URL + "/email/contactTopics";
        return await HttpService.get(url, 'email/contactTopics');
    } catch (e) {
        throw(e);
    }
}

const handleError = (error: any) => {
    console.error("Error in contact services: " + JSON.stringify(error));
    const errorMsg = error.message;
    return errorMsg;
};
